import { requestTypeToStatusParam } from "./sponsorScopedDetailsUrl";

/** Join request status that Diligent can still accept or reject. */
export const JOIN_REQUEST_PENDING_STATUS = "Pending";

/**
 * Join request id an admin can accept or reject from an Assessment Requests grid row:
 * only a pending joiner's row ("Request Pending") that is not archived.
 */
export function pendingJoinRequestIdForGridRow(item) {
  if (requestTypeToStatusParam(item?.request_type) !== "pending") return null;
  if (String(item?.vqa_request_status ?? "").toLowerCase() === "archived") return null;
  return item?.join_vqa_request_id ?? null;
}

/** Same decision for the admin Assessment Details instance of one joining sponsor. */
export function pendingJoinRequestIdForDetails(joinDetails) {
  if (joinDetails?.join_vqa_request_status !== JOIN_REQUEST_PENDING_STATUS) return null;
  return joinDetails.join_vqa_request_id ?? null;
}

/**
 * Request Date on admin Assessment Details: the date this sponsor submitted its own
 * request — the join request for a joiner's instance, the original request otherwise.
 */
export function adminDetailsRequestDate(vqaDetails, joinDetails) {
  return joinDetails?.join_vqa_request_created_on ?? vqaDetails?.vqa_request_created_on;
}
